<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-evgImport-usfsOrderData',
  components: { PageTable },
}
</script>
